<template>
  <div class="conditional-content">
    <Block
      :config="currentViewBlock.options"
      :key="`${keyBase}-block-${currentView.id}-${currentViewBlock.key}`"
      :type="currentViewBlock.type"
      v-if="currentViewBlock"
      :translation-context="blockTranslationContext()"
    ></Block>
  </div>
</template>
<script>
import DisplayConditionsMixin from '../../../lib/DisplayConditionsMixin';
export default {
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    view: { type: Number, default: 0 },
  },
  components: {
    Block: () => import('../Block.vue'),
  },
  inject: ['translationContext'],
  mixins: [DisplayConditionsMixin],
  data() {
    return {
      localViews: [],
      viewIndex: 0,
    };
  },
  created() {
    this.content = this.config;
    this.localViews = this.content.views;
    this.viewIndex = this.viewMeetingConditions();
  },
  computed: {
    currentView() {
      return this.localViews[this.viewIndex];
    },
    currentViewBlock() {
      return this.currentView.block;
    },
    keyBase() {
      return this.$vnode.key;
    },
  },
  methods: {
    blockTranslationContext(key) {
      return `${this.translationContext}.conditional.${this.currentView.id}.block.${this.currentViewBlock.key}`;
    },
    viewMeetingConditions() {
      // Skip the first view. We fallback to it if nothing else meets the display conditions
      for (let i = 1; i < this.localViews.length; i++) {
        const view = this.localViews[i];
        if (this.meetsDisplayConditions(view.display)) {
          return i;
        }
      }
      return 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.cc-settings {
  background-color: #bef8fe;
  padding: 3px;
  text-decoration: none !important;
  span {
    font-size: 13px;
    vertical-align: 3px;
  }
}
.no-block {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #dedede;
  color: #888;
}
</style>
